import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("获取")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_space = _resolveComponent("a-space")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_page_header = _resolveComponent("a-page-header")
  const _component_ppt_editor = _resolveComponent("ppt-editor")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_page_header, {
      title: "预览课件",
      subTitle: $setup.fileName,
      style: {"background-color":"white"}
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            ($setup.canCopy)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: $setup.handleShowWarning,
                  style: _normalizeStyle({ disabled: $setup.loading }),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick", "style"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, { onClick: $setup.handleGoBack }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createElementVNode("span", null, "人气值：" + _toDisplayString($setup.fileInfo?.popularity?.popularity || 0), 1),
            _createElementVNode("span", null, "下载量：" + _toDisplayString($setup.fileInfo?.popularity?.download_num || 0), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["subTitle"]),
    _createVNode(_component_ppt_editor, {
      resource: $setup.url,
      ref: "pptEditor",
      type: "preview",
      resourceType: "official",
      width: "100%",
      height: "90vh",
      autoHideMenu: true
    }, null, 8, ["resource"])
  ], 64))
}